import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import {
  ASTREA_HOMOLOG_OVERRIDE_STORAGE_KEY,
  ASTREA_HOMOLOG_OVERRIDE_TARGETS,
  ASTREA_PLAYGROUND_URL_STORAGE_KEY,
} from '../constants/astreaHomologOverride'

const NONE = 'NONE'

export function useAstreaHomologOverride() {
  const queryClient = useQueryClient()
  const [target, setTargetState] = useState(() => {
    const stored = localStorage.getItem(ASTREA_HOMOLOG_OVERRIDE_STORAGE_KEY)
    return ASTREA_HOMOLOG_OVERRIDE_TARGETS.includes(stored) ? stored : NONE
  })

  function setTarget(nextTarget) {
    if (ASTREA_HOMOLOG_OVERRIDE_TARGETS.includes(nextTarget)) {
      localStorage.setItem(ASTREA_HOMOLOG_OVERRIDE_STORAGE_KEY, nextTarget)
    } else {
      localStorage.removeItem(ASTREA_HOMOLOG_OVERRIDE_STORAGE_KEY)
    }

    setTargetState(nextTarget)
    queryClient.invalidateQueries({ queryKey: ['astreaEnvironment'] })
  }

  const [playgroundUrl, setPlaygroundUrlState] = useState(
    () => localStorage.getItem(ASTREA_PLAYGROUND_URL_STORAGE_KEY) || '',
  )

  function setPlaygroundUrl(nextUrl) {
    if (nextUrl) {
      localStorage.setItem(ASTREA_PLAYGROUND_URL_STORAGE_KEY, nextUrl)
    } else {
      localStorage.removeItem(ASTREA_PLAYGROUND_URL_STORAGE_KEY)
    }

    setPlaygroundUrlState(nextUrl)
    queryClient.invalidateQueries({ queryKey: ['astreaEnvironment'] })
  }

  return { target, setTarget, playgroundUrl, setPlaygroundUrl }
}

export default useAstreaHomologOverride
